import { createValidation } from '_metronic/helpers/crud-helper/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export type EmpresaSchemaMode = 'empresa' | 'cliente'

export const empresaValorSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    especialidades: Yup.array().nullable().notRequired(),
    valor: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .required(v.requiredField('valor'))
      .min(1, v.minValueField(1)),
    valorRetorno: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .notRequired()
      .min(1, v.minValueField(1)),

    tipoAtendimento: Yup.object().nullable().required(v.requiredField('tipoAtendimento')),
    minimo: Yup.number()
      .nullable()
      .notRequired()
      .integer('A quantidade mínima deve ser um número inteiro')
      .min(0, 'O valor precisa ser maior ou igual a 0'),
  })
}
